export default __webpack_public_path__ + "static/media/cx.a0e97b7d.svg";